import { handleApiRequest } from '../services/transports';

import { REACT_APP_RSD_DOMAIN } from './base';

export const searchDeactivationReasonMatrix = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}report-service/api/portal/DrugReports/deactivation-reason-matrix`,
  method: 'get',
  query
});

export const searchsStatusMatrix = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}report-service/api/portal/DrugReports/status-matrix`,
  method: 'get',
  query
});

export const searchSystemParameter = () => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}system-management/api/portal/SystemParameter/system-parameter-list`,
  method: 'get'
});

export const updateSystemParameter = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}system-management/api/portal/SystemParameter/edit-system-parameter`,
  method: 'put',
  data
});

export const searchLabels = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DataLable/mp-List-labeles`,
  method: 'get',
  query
});

export const AddLabel = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DataLable/mp-create-label`,
  method: 'post',
  data
});

export const EditLabel = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DataLable/mp-Edit-label`,
  method: 'put',
  data
});

export const DeleteLabel = id => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DataLable/mp-delete-label/${id}`,
  method: 'put'
});

export const labelsHistory = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DataLable/mp-label-history`,
  method: 'get',
  query
});

export const searchLabelLevelTypes = () => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DataLable/mp-List-label-types`,
  method: 'get'
});

export const searchLabelName = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DataLable/mp-label-search`,
  method: 'get',
  query
});

export const GetLabelById = labelId => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DataLable/mp-label-details-by-id`,
  method: 'get',
  query: { LabelId: labelId }
});

export const GetLabeledDataUploadedByExcel = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DataLable/mp-list-labeled-data-uploaded-by-excel`,
  method: 'get',
  query
});

export const GetLabeledDataUploadedManually = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/DataLable/mp-list-labeled-data-uploaded-manually`,
  method: 'get',
  query
});

